import { TRIGER_SUBSCRIPTION_POP_UP } from '../types';
import { setSubscriptionPopUp }  from '../actions/uiActions';
import { getDataSubscriptionPopUp }  from '../actions/stripeActions';
import { signOut }  from '../actions/authActions';

export const subscriptionMiddleware = ({dispatch,getState}) => (next) => {
	return async (action) => {

		if(action.type === TRIGER_SUBSCRIPTION_POP_UP) {
      dispatch(setSubscriptionPopUp(action.payload));
      dispatch(getDataSubscriptionPopUp());

			return dispatch(signOut());
    };
    
		return next(action);
	};
};
